import { render, staticRenderFns } from "./MainController.vue?vue&type=template&id=355e6d34&"
import script from "./MainController.vue?vue&type=script&lang=js&"
export * from "./MainController.vue?vue&type=script&lang=js&"
import style0 from "./MainController.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports